import {
  CloudServerOutlined,
  KeyOutlined,
  SolutionOutlined,
  UserOutlined,
} from "@ant-design/icons";
import type { TargetNodeType } from "@p0security/shared/types/assessment/data/index";
import { Tooltip } from "@p0security/ui";
import { startCase } from "lodash";
import React from "react";

const iconMap: Record<TargetNodeType, React.ReactNode> = {
  credential: <KeyOutlined />,
  grant: <SolutionOutlined />,
  identity: <UserOutlined />,
  resource: <CloudServerOutlined />,
};

/** Returns the shared icon used for a findings target node type. */
export const targetNodeTypeIconFor = (show: TargetNodeType): React.ReactNode =>
  iconMap[show];

export const MonitorTypeIcon: React.FC<{ show: TargetNodeType }> = ({
  show,
}) => (
  <Tooltip title={startCase(show)}>
    <span className="text-[1.2em]">{targetNodeTypeIconFor(show)}</span>
  </Tooltip>
);
